"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSDK = exports.SDKProvider = void 0;
const react_1 = __importStar(require("react"));
const SdkContext = react_1.default.createContext(null);
SdkContext.displayName = 'CogniteSdkProvider';
function SDKProvider({ sdk, children }) {
    return react_1.default.createElement(SdkContext.Provider, { value: sdk }, children);
}
exports.SDKProvider = SDKProvider;
const useSDK = () => {
    const sdk = (0, react_1.useContext)(SdkContext);
    if (!sdk) {
        throw new Error(`SdkContext not found, add '<SDKProvider value={sdk}>' around your component/app`);
    }
    return sdk;
};
exports.useSDK = useSDK;
